import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { UserMenuNodes } from 'src/app/models/user-menu-nodes';
import { GeneralService } from 'src/app/services/general.service';
import { DataService } from "../data-service/data.service.service";
import { EstimateService } from 'src/app/services/estimate.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Routes, RouterModule, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { CreateUpdateTaskComponent } from '../create-update-task/create-update-task.component';
import { NewActivityComponent } from 'src/app/pages/home/new-activity/new-activity.component';
import { ModalModule, WavesModule, InputsModule, ButtonsModule, ToastService } from 'ng-uikit-pro-standard'
import { NewEmpleoyeActivitiesComponent } from 'src/app/pages/sales-management/employee-activities/forms/new-empleoye-activities/new-empleoye-activities.component';
import { NewCustomerComponent } from 'src/app/pages/sales-management/employee-activities/forms/new-customer/new-customer.component';
import { CreateUpdateSalesProjectComponent } from 'src/app/pages/sales-management/sales-project/create-update-sales-project/create-update-sales-project.component';
import { ConfigService } from 'src/app/services/config.service';
import CustomStore from 'devextreme/data/custom_store';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectService } from 'src/app/services/project.service';
import { DxDropDownBoxComponent, DxSelectBoxComponent, DxTreeViewComponent } from 'devextreme-angular';
import { SimpleViewCommissioningComponent } from 'src/app/pages/simpleView/simple-view-commissioning/simple-view-commissioning.component';
import { DatePipe, Location } from '@angular/common';

import { VoiceRecognitionService } from '../../services/voice-recognition.service';
import { TextToVoiceService } from '../../services/text-to-voice.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { ApplicationsComponent } from 'src/app/pages/shop/applications/applications.component';

declare var $: any;

export interface ChatSummary {
  id: string;        // identificador único del chat (lo usamos como clave en localStorage)
  title: string;     // título que mostramos en la lista (p.ej. la 1ª línea del usuario)
  createdAt: string; // fecha/hora ISO cuando se creó
  updatedAt: string; // fecha/hora ISO de la última actividad (para ordenar)
  threadid: string; // fecha/hora ISO de la última actividad (para ordenar)
  pinned?: boolean;  // opcional: si está fijado arriba
}

@Component({
  selector: 'app-navbar-sidebar',
  templateUrl: './navbar-sidebar.component.html',
  styleUrls: ['./navbar-sidebar.component.scss']
})
export class NavbarSidebarComponent implements OnInit, AfterViewChecked {

  @ViewChild("searchProject", { static: false }) searchProject: DxSelectBoxComponent;

  // @ViewChild('dataCards', { static: false }) dataCards: SimpleViewCommissioningComponent;
  @ViewChild("dataCards", { static: false }) dataCards: SimpleViewCommissioningComponent;

  @ViewChild("messagesContainer", { static: false }) messagesContainer: ElementRef;

  @ViewChild('treeviewType', { static: false }) treeviewType: DxTreeViewComponent;
  @ViewChild('treeviewTag', { static: false }) treeviewTag: DxTreeViewComponent;


  @ViewChild('treeBoxType', { static: false }) treeBoxType: DxDropDownBoxComponent;
  @ViewChild('treeBoxTags', { static: false }) treeBoxTags: DxDropDownBoxComponent;



  // @ViewChild('ApplicationsComponentFunctions', { static: true }) ApplicationsComponentFunctions: ApplicationsComponent; 

  @ViewChild(ApplicationsComponent, { static: true }) ApplicationsComponentFunctions: ApplicationsComponent;

  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView2;

  threadid: string = '';
  search: string = '';

  emailList: any;
  emailPopup = false;
  plusSiteButton: any;
  plusSubjectemailButton: any;
  cancelButtonPopupemail: any;
  cleanButtonPopupemail: any;
  sendButtonPopupemail: any;
  updatetemplateButtonPopupemail: any;
  popupVisibleTemplates: boolean;
  isMultiline = false;
  toolbarButtonOptions: any = {
    icon: 'fas fa-layer-group',
    stylingMode: 'text',
    hint: "Templates",
    onClick: () => this.popupVisibleTemplates = true,
  };

  popupSettings2 = false;
  PopupTerms = false;

  defaultVisible: boolean;
  withTitleVisible: boolean;
  withAnimationOptionsVisible: boolean;
  withShadingOptionsVisible: boolean;

  savedChats: ChatSummary[] = [];
  pinnedChats: ChatSummary[] = [];
  unpinnedChats: ChatSummary[] = [];
  currentChatId: string | null = null;

  name = '';
  isSideBarVisible: boolean = true;
  showNavbarCommissioning: boolean = false
  userNemu: any;
  menu: any;
  currentactiveComponents: any;
  userName: string;
  options: any;

  confirmDeletePopup: boolean = false;

  currentUserId = localStorage.getItem('customerid');
  userSetting: any = { lat: 0, long: 0, geoname: '' };
  currentUserCompanyId: number = 0;

  // @Input() userName: string;
  languageSelect: Array<any> = [
    { value: 1, label: 'English', traduction: 'en' },
    // { value: 2, label: 'Español', traduction: 'es' },
    // { value: 3, label: 'Français', traduction: 'fr' }
  ];
  currencySelect: Array<any> = [];
  timeformSelect: Array<any>;
  timezoneSelect: Array<any> = [];
  startpageSelect: Array<any> = [];
  sesiontimeSelect: Array<any>;
  dateformSelect: Array<any> = [];
  UserCompanyName: string;
  openAI = false;

  skipIntroduction = false;

  appUser: string;

  isRecording: boolean = false;

  savingUserSetting = false;
  message: any;
  isNavCollapse = false;
  typeSupport = [];
  currentUrl = '';
  @Output() navCollapseOut: EventEmitter<any> = new EventEmitter<any>();
  @Output() outputVisibleNav: EventEmitter<any> = new EventEmitter<any>();

  modelChangePassword = {
    pass: '',
    confirmPass: ''
  };
  popupTask = false;
  popupEmployeeActivity = false;
  popupCustomer = false;
  popupNewContact = false;
  popupCreateSalesProject = false;
  popupSWOClient = false;
  popupNewRFI = false;
  popupPunchList = false;
  popupProgressReport = false;

  LinkGettingStarted: string;
  LinkCubeFlow: string;
  LinkWhatsNew: string;
  dashboardURL: string;

  // VARIABLES ALARMAS

  PopupAlarm: boolean = false;
  PopupChangeCompany: boolean = false;
  PhasesAlarm: any[] = [];
  customOperations: Array<any>;
  popupPosition: any;
  TotalAlarms: number = 0;
  enablePopupWorkFlowAlarm: boolean = false;
  enablePopupCompaniewAlarm: boolean = false;



  cancelButtonTasK: any;
  saveButtonTasK: any;
  saveNewButtonTasK: any;
  saveEditButtonTasK: any;
  @ViewChild('newtask', { static: false }) newtask: CreateUpdateTaskComponent;

  cancelButtonNewEmployee: any;
  saveButtonNewEmployee: any;
  saveNewButtonNewEmployee: any;
  saveEditButtonNewEmployee: any;
  @ViewChild('newActivity', { static: false }) newActivity: NewEmpleoyeActivitiesComponent;

  cancelButtonNewCustomer: any;
  saveButtonNewCustomer: any;
  saveNewButtonNewCustomer: any;
  saveEditButtonNewCustomer: any;
  @ViewChild('newcustomer', { static: false }) newcustomer: NewCustomerComponent;

  cancelButtonNewSales: any;
  saveButtonNewSales: any;
  saveNewButtonNewSales: any;
  saveEditButtonNewSales: any;
  @ViewChild('componentSales', { static: false }) componentSales: CreateUpdateSalesProjectComponent;

  @ViewChild('componentCUBEcx', { static: false }) componentCUBEcx: SimpleViewCommissioningComponent;
  popupChatbox: boolean = false;

  userInput: string = '';

  messages: {
    author: string;
    text: string;
    time: string;
    authorName: string;
    quickReplies?: { title: string; description: string }[]; // ← nueva propiedad opcional
  }[] = [];

  messagescopy: { author: string, text: string, time: string, authorName: string }[] = [
  ];

  products: any;
  product: number;
  searchModeOption: string = "contains";
  searchExprOption: any = "NAME";
  searchTimeoutOption: number = 200;
  minSearchLengthOption: number = 0;
  showDataBeforeSearchOption: boolean = false;
  clients: any = [];

  clickedButtonIndex: number = -1;

  template = {
    id: 0,
    text: '',
    active: 1,
    subject: '',
    createdate: '',
    updateddate: '',
    updatedbyid: '',
    tag: '',
    metadata: '',
    method: 'InsertUpdateNotificationEmailTemplate'
  };

  acceptterm: string = "0";

  arrayTemplate: any;
  allTemplate: any;

  detailEmail: any = [];
  selectionModeValueList = 'multiple';
  emailCategory: any;
  selectionModeValue = 'single';
  selectAllModeVlaue = 'page';
  isButtonDisabled: boolean = true;
  lastThreadID: string = "";

  fromQuickAccess = true;

  regionsSelect: any = [];

  popupSalesLead: boolean = false;
  popupNewEstimateQuick: boolean = false
  firstFormGroup: FormGroup;
  projectslist: CustomStore;
  projectName: any = ""
  popupCreateSalesProject2: boolean = false
  addCustomerButton: { icon: string; type: string; hint?: string; onClick: () => void; };

  menuDinamico: any[] = []

  lastUserInput: string = '';

  layoutData: any[] = [
    {
      value: 'Horizontal',
      label: 'Horizontal'
    },
    {
      value: 'Vertical',
      label: 'Vertical'
    },
  ]
  planid: string;
  popupInsufficientCredits: boolean;


  constructor(
    private router: Router,
    private data: DataService,
    private location: Location,
    private toast: ToastService,
    public userService: UserService,
    public translate: TranslateService,
    public configService: ConfigService,
    public appSettings: AppConfigService,
    private activatedRoute: ActivatedRoute,
    private generalService: GeneralService,
    private ProjectService: ProjectService,
    private deltaService: DeltaworldService,
    private settingsImage: CompanySettingsService,
    private estimateService: EstimateService,
    public settingsCompany: CompanySettingsService,
    public service: VoiceRecognitionService,
    private textToVoiceService: TextToVoiceService,
    private MapInformationService: MapInformationService,
  ) {



    this.service.init();

    



    this.detailEmail = [{
      ID: 1,
      CompanyName: 'Super Mart of the West',
      Address: '702 SW 8th Street',
      City: 'Bentonville',
      State: 'Arkansas',
      Zipcode: 72716,
      Phone: '(800) 555-2797',
      Fax: '(800) 555-2171',
      Website: 'http://www.nowebsitesupermart.com',
    }];

    this.emailCategory = [
      {
        ID: 1,
        Name: 'Incoming',

      },
      {
        ID: 2,
        Name: 'Outgoing',
      },
      {
        ID: 3,
        Name: 'Draft',
      },
      {
        ID: 4,
        Name: 'Delete',
      }
    ];

    this.emailList = [{
      key: '2022/01/04',
      items: ['Choose between PPO and HMO Health Plan',
        'Google AdWords Strategy',
        'New Brochures',
        'Update NDA Agreement',
        'Review Product Recall Report by Engineering Team',
        'Review Product Recall Report by Engineering Team',
        'Review Product Recall Report by Engineering Team',
        'Review Product Recall Report by Engineering Team',
        'Choose between PPO and HMO Health Plan',
        'Google AdWords Strategy',
        'New Brochures',
        'Update NDA Agreement',
        'Review Product Recall Report by Engineering Team',
        'Review Product Recall Report by Engineering Team',
        'Review Product Recall Report by Engineering Team',
        'Review Product Recall Report by Engineering Team'
      ]
    }
    ];

    this.arrayTemplate = [{
      key: 'Create Templates',
      items: [{ subject: 'Save as new template' }],
    },
    {
      key: 'Custom Template',
      items: [],
    }
    ];

    //modales


    this.plusSubjectemailButton = {
      icon: "fas fa-paperclip",
      type: "button",
      elementAttr: {
        id: 'c-green'
      },
      onClick: () => {
      }
    };

    this.cancelButtonPopupemail = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.emailPopup = false;
        this.clearTemplate()
        this.deleteUpdateTemplate()
      },
    };

    this.cleanButtonPopupemail = {
      text: 'Clear Template',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.clearTemplate()
      },
    };

    this.sendButtonPopupemail = {
      text: 'Send',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {

      },
    };

    this.addCustomerButton = {
      icon: "plus",
      hint: "Add Project",
      type: "button",
      onClick: () => {
        this.popupCreateSalesProject2 = true;
      },
    };

    this.defaultVisible = false;
    this.withTitleVisible = false;
    this.withAnimationOptionsVisible = false;
    this.withShadingOptionsVisible = false;

    let settings = {
      dateFormat: this.appSettings.appConfig.dateFormat,
      moneyFormat: this.appSettings.appConfig.moneyFormat,
      layout: this.appSettings.appConfig.layout,
      startPage: ''
    }
    this.LinkGettingStarted = this.appSettings.appConfig.LinkGettingStarted;
    this.LinkCubeFlow = this.appSettings.appConfig.LinkCubeFlow;
    this.LinkWhatsNew = this.appSettings.appConfig.LinkWhatsNew;
    this.dashboardURL = this.appSettings.appConfig.dashboardURL;


    this.userNemu = [];
    const isclient = localStorage.getItem('isClient');
    if (isclient) {
      this.userService.isClient.next(JSON.parse(isclient.toLocaleLowerCase()));
    }


    this.currencySelect = this.appSettings.appConfig.currencyData;
    this.dateformSelect = this.appSettings.appConfig.dateFormatData;
    this.getRegions();

    if (this.userService.settings.value.languageid == undefined)
      this.userService.settings.value.languageid = 1;

    // sessionStorage.setItem('moduleId', '15');
  }

  getRegions() {

    var mytoken = localStorage.getItem('token');

    if (mytoken) {
      this.estimateService.Get_ProjectRegionID('dummyData').subscribe(result => {
        this.regionsSelect = result.map(x => {
          x.value = x.Id;
          x.label = x.DivisionName;
          x.code = x.Id;
          return x;
        });
      })
    }

  }

  changeTab(target) {
    switch (target.itemIndex) {
      case 0:
        break
      case 1:
        //Events
        break
      case 2:
        //Reports
        break
    }
  }

  changeStartPage(obj) {
    // this.userSettings.startPage = obj.selectedItem.NCUBELINK;
  }
  goTraining() {
    this.router.navigateByUrl('/Training');
  }

  cancelButtonEmail() {
    this.emailPopup = false;
    this.clearTemplate();
    this.deleteUpdateTemplate();
  };

  onCompanyChanged(e) {
    this.currentUserCompanyId = e.value;
  }

  getString(obj) {
    return JSON.stringify(obj)
  }

  updateDefaultCompany() {
    this.PopupChangeCompany = false;

    this.userService.UpdateUserDefaultClient(this.currentUserCompanyId).subscribe(result => {
      localStorage.setItem('autoStart', '1');
      this.router.navigateByUrl('/login');
    });
  }


  getSetting() {
    this.userService.Get_UserSettingsCE(localStorage.getItem('customerid')).subscribe(result => {

      if (result.length > 0 && result[0].CLIENTUSERSETTING) {
        let obj = JSON.parse(result[0].CLIENTUSERSETTING);

        localStorage.setItem('regionId', result[0].RegionID)
        localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
        localStorage.setItem('UserCompanyName', result[0].UserCompanyName);
        localStorage.setItem('cubeclientid', result[0].cubeclientid);
        // localStorage.setItem('showbotintro', result[0].SHOWBOTINTRO);


        // const showBotIntro = localStorage.getItem('showbotintro');
        // if (showBotIntro !== null && showBotIntro === '0') {
        //   this.skipIntroduction = true;
        // }      
        // else{
        //   this.skipIntroduction = false;
        // }

        let language = this.languageSelect.find(x => x.value == obj.languageid);
        if (language) {
          this.translate.use(language.traduction);
        }

        if (obj) {
          this.userService.settings.next(obj);
          setTimeout(() => {

            this.userService.settings.value.layout = obj.layout
            this.userService.settings.value.regionid = obj.regionid
            this.userService.settings.value.languageid = obj.languageid
            this.userService.settings.value.map = obj.map
            this.userService.settings.value.lat = obj.lat
            this.userService.settings.value.long = obj.long

            this.userSetting.lat = obj.lat
            this.userSetting.long = obj.long

          }, 500);
        }

      }
    });
  }

  dontShow: boolean = true
  moduloName: any = ""
  showLayout: boolean = false
  showNavbarCR: boolean = false
  dataMenuNavbar: any

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  private scrollToBottom(): void {
    if (this.messagesContainer) {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    }
  }

  clientplanid: any
  ngOnInit() {


    this.Bot_getOldChatsByUser();

    this.pinnedChats = [
      {
        id: 'CHAT001',
        title: 'Soporte técnico HVAC',
        createdAt: '2025-08-01T09:00:00Z',
        updatedAt: '2025-08-13T14:45:00Z',
        threadid: 'JGJUGHJKHK',
        pinned: true
      },
      {
        id: 'CHAT002',
        title: 'Proyecto Alpha - Seguimiento',
        createdAt: '2025-08-03T10:15:00Z',
        updatedAt: '2025-08-12T16:30:00Z',
        threadid: 'JGJUGHJKHK',
        pinned: true
      }
    ];

    this.unpinnedChats = [
      {
        id: 'CHAT003',
        title: 'Cotización sistema de control',
        createdAt: '2025-08-05T11:20:00Z',
        updatedAt: '2025-08-13T10:05:00Z',
        threadid: 'JGJUGHJKHK',
        pinned: false
      },
      {
        id: 'CHAT004',
        title: 'Revisión de planos eléctricos',
        createdAt: '2025-08-06T08:00:00Z',
        updatedAt: '2025-08-11T09:40:00Z',
        threadid: 'JGJUGHJKHK',
        pinned: false
      },
      {
        id: 'CHAT005',
        title: 'Reunión de coordinación interna',
        createdAt: '2025-08-07T13:10:00Z',
        updatedAt: '2025-08-10T12:00:00Z',
        threadid: 'JGJUGHJKHK',
        pinned: false
      }
    ];



    const raw = localStorage.getItem('OpenModalNextTime');

    if (raw) {
      // Bórralo SIEMPRE para evitar re-ejecuciones
      localStorage.removeItem('OpenModalNextTime');

      this.modalChatboxOPENAI();

      return;

    }

    setTimeout(() => {
      this.clientplanid = localStorage.getItem("clientplanid")
    }, 2000);


    this.getTemplatesEmail()

    // Subscribe to the configChanged$ observable
    this.appSettings.configChanged$.subscribe(() => {
      // Handle the config change event
      this.handleConfigChange();
    });

    this.router.events.subscribe(event => {

      this.userName = localStorage.getItem('userName');
      if ((this.userName != null) && (this.appSettings.appConfig.dashboardURL == null)) {
        this.configService.loadConfigFromDB().subscribe(resultsett => {
          this.appSettings.expandSettings(resultsett[0])
        }, err => {
          this.router.navigateByUrl('/home')
        }
        );
      }

      this.UserCompanyName = localStorage.getItem('UserCompanyName');
      this.acceptterm = localStorage.getItem('termaccepted');

      if (this.acceptterm == "0") {
        this.PopupTerms = true;
      }

      // this.isClient = this.userService.isClient.value; 

      // if (this.componentCUBEcx != undefined){

      // }


      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.name = (<any>event).url.split("/").slice(-1)[0];
        this.dataMenuNavbar = this.name.split("?")[0]




        if (this.name == '' || this.name == 'cartPlans' || this.name == 'completedJobs' || this.name == 'RecoverPasswordCW' || this.name == 'createuserCW' || this.name == 'dashboardTalents' || this.name == 'logincubeworks' || this.name == 'login' || this.name == 'loginUserTemp' || this.name == 'NewAccount' || this.name == 'RecoverPassword' || this.name == 'CompanyRegistration' || this.name == 'clientuser' || this.name == 'Payment' || this.name == 'externaluser' || this.name == 'registerCompany' || this.name == 'companyRegistration' || this.name == 'payment' || this.name == 'plans' || this.name.indexOf('actPass') > -1
          || this.name == 'myCart' || this.name == 'applications' || this.name == 'yourOrder' || this.name == 'orderDetail' || this.name == 'order' || this.name == 'newShippingAddress' || this.name == 'shippingAddress' || this.name == 'newPayment' || this.name == 'creditcard' || this.name == 'paymentCart' || this.name == 'productsDetails' || this.name == 'productsCart' || this.name == 'productsCategory'
          || this.name == 'ApplicationType' || this.dataMenuNavbar == 'myCart' || this.dataMenuNavbar == 'applications' || this.dataMenuNavbar == 'yourOrder' || this.dataMenuNavbar == 'orderDetail' || this.dataMenuNavbar == 'order' || this.dataMenuNavbar == 'newShippingAddress' || this.dataMenuNavbar == 'shippingAddress' || this.dataMenuNavbar == 'newPayment' || this.dataMenuNavbar == 'creditcard' || this.dataMenuNavbar == 'paymentCart' || this.dataMenuNavbar == 'productsDetails' || this.dataMenuNavbar == 'productsCart' || this.dataMenuNavbar == 'productsCategory'
          || this.dataMenuNavbar == 'ApplicationType' || this.dataMenuNavbar == 'ListSystems' || this.dataMenuNavbar == 'MyProjects'
          || this.dataMenuNavbar == 'DetailProject' || this.dataMenuNavbar == 'Applicationfiltered' || this.dataMenuNavbar == 'AIShop'
          || this.name == 'registration-form' || this.dataMenuNavbar == 'registration-form'
        ) {
          this.isSideBarVisible = false;
          this.dontShow = true

          if (this.dataMenuNavbar == 'myCart' || this.dataMenuNavbar == 'applications' || this.dataMenuNavbar == 'yourOrder' || this.dataMenuNavbar == 'orderDetail' || this.dataMenuNavbar == 'order' || this.dataMenuNavbar == 'newShippingAddress' || this.dataMenuNavbar == 'shippingAddress' || this.dataMenuNavbar == 'newPayment' || this.dataMenuNavbar == 'creditcard' || this.dataMenuNavbar == 'paymentCart' || this.dataMenuNavbar == 'productsDetails' || this.dataMenuNavbar == 'productsCart' || this.dataMenuNavbar == 'productsCategory'
            || this.dataMenuNavbar == 'ApplicationType' || this.dataMenuNavbar == 'ListSystems' || this.dataMenuNavbar == 'MyProjects'
            || this.dataMenuNavbar == 'DetailProject' || this.dataMenuNavbar == 'Applicationfiltered' || this.dataMenuNavbar == 'AIShop'
          ) {

            this.showNavbarCR = true
          } else {
            this.showNavbarCR = false
          }

        }
        else {
          this.isSideBarVisible = true;
          this.showNavbarCR = false
          this.getMenu();
          // Agregado por Evander
          this.getAlarms()
          // Get UserCompanies
          // get Settings
          this.getSetting()
          this.userService.GetUserClients().subscribe(result => {
            this.clients = result;
          });

          this.currentUserId = localStorage.getItem('customerid');
          this.showLayout = localStorage.getItem('isBabyCube') == "Yes" ? false : true

          this.currencySelect = this.appSettings.appConfigJson.currencyData;
          this.dateformSelect = this.appSettings.appConfigJson.dateFormatData;
          if (this.startpageSelect.length == 0) {

            if (this.currentUserId) {
              this.userService.Get_UserSettingsCE(this.currentUserId).subscribe(result => {

                if (result.length > 0 && result[0].CLIENTUSERSETTING) {
                  let obj = JSON.parse(result[0].CLIENTUSERSETTING);

                  localStorage.setItem('regionId', result[0].RegionID)
                  localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
                  localStorage.setItem('UserCompanyName', result[0].UserCompanyName);
                  localStorage.setItem('cubeclientid', result[0].cubeclientid);

                  let language = this.languageSelect.find(x => x.value == obj.languageid);
                  if (language) {
                    this.translate.use(language.traduction);
                  }

                  if (obj) {
                    this.userService.settings.next(obj);
                    setTimeout(() => {

                      this.userService.settings.value.layout = obj.layout
                      this.userService.settings.value.regionid = obj.regionid
                      this.userService.settings.value.languageid = obj.languageid
                      this.userService.settings.value.map = obj.map
                      this.userService.settings.value.lat = obj.lat
                      this.userService.settings.value.long = obj.long
                      this.userSetting.lat = obj.lat
                      this.userSetting.long = obj.long
                    }, 500);
                  }

                }
              });

              this.userService.Get_ClientUserStartPagesCE().subscribe(result => {
                const infoModules = result.filter(x => x.NCUBELINK != 'NULL');
                this.startpageSelect = infoModules.map(x => {
                  x.value = x.NCUBELINK;
                  x.label = x.MODULENAME;
                  x.code = x.NCUBELINK;
                  return x;
                });
              });
            }
          }

          if (localStorage.getItem("NavbarHorizontal") == "Yes") {
            this.isSideBarVisible = false
            this.dontShow = true
            this.showNavbarCommissioning = true
            const modulo = this.activatedRoute.snapshot.queryParamMap.get("moduleName");
            const currentUrl = this.router.routerState.snapshot.url

            if (currentUrl == "/dashboard") {
              this.moduloName = "dashboard"
            } else {
              if (decodeURIComponent(modulo) == "Help") {
                this.moduloName = ""
              } else {
                this.moduloName = decodeURIComponent(modulo)
                // this.showCardHelp = false
                // this.getCards()
              }
            }
            setTimeout(() => {
              this.menuDinamico = JSON.parse(localStorage.getItem('userMenu')).userMenuNodes
              this.settingsImage.GetImgLogoPath().subscribe(result => {
                this.settingsImage.GetDocument(result[0].FILEPATH).subscribe(result2 => {
                  var data = result2.filestring.substring(0, 5);
                  let tipo = ""
                  switch (data.toUpperCase()) {
                    case "/9J/4": tipo = "jpeg";
                      break
                    default:
                      tipo = "png"
                      break
                  }

                  // this.base64Logo = 'data:image/' + tipo + ';base64,' + result2.filestring;

                  if (result2.filestring != '' && result2.filestring != undefined) {
                    this.base64Logo = 'data:image/' + tipo + ';base64,' + result2.filestring;
                  } else {
                    this.base64Logo = ''
                  }

                })
              })
            }, 500);
          } else {
            setTimeout(() => {
              this.settingsImage.GetImgLogoPath().subscribe(result => {
                this.settingsImage.GetDocument(result[0].FILEPATH).subscribe(result2 => {
                  var data = result2.filestring.substring(0, 5);
                  let tipo = ""
                  switch (data.toUpperCase()) {
                    case "/9J/4": tipo = "jpeg";
                      break
                    default:
                      tipo = "png"
                      break
                  }

                  if (result2.filestring != '' && result2.filestring != undefined) {
                    this.base64Logo = 'data:image/' + tipo + ';base64,' + result2.filestring;
                  } else {
                    this.base64Logo = ''
                  }
                })
              })
            }, 500);
          }


          if (localStorage.getItem("cubeWorksOnly") == "Yes") {
            this.isSideBarVisible = false
            this.dontShow = false
          }

        }
      }
      if (event.constructor.name === "NavigationEnd") { }
      this.outputVisibleNav.emit(this.isSideBarVisible);

    });

    this.typeSupport = [
      { value: 1, label: 'Type Support 1' },
    ];
    // this.languageSelect = [
    //   { value: 1, label: 'English' },
    //   { value: 2, label: 'Español' },
    //   { value: 3, label: 'Français' }
    // ];

    this.timeformSelect = [
      { value: '1', label: '12 Hours' },
      { value: '2', label: '24 Hours' },
    ];

    this.timezoneSelect = [
      { value: '1', label: '(GMT-11:00) International Date Line West' },
      { value: '2', label: '(GMT-11:00) Midway Island' },
      { value: '3', label: '(GMT-04:00) Samoa' },
      { value: '4', label: '(GMT-10:00) Hawaii' },
      { value: '5', label: '(GMT-04:00) Caracas' }

    ];

    // this.startpageSelect = [
    //   { value: '1', label: 'Option 1' },
    //   { value: '2', label: 'Option 2' },
    //   { value: '3', label: 'Option 3' },
    //   { value: '4', label: 'Option 4' },
    //   { value: '5', label: 'Option 5' }

    // ];

    this.sesiontimeSelect = [
      { value: '1', label: '20 Min' },
      { value: '2', label: '30 Min' },
      { value: '3', label: '40 Min' },
      { value: '4', label: '50 Min' },
      { value: '5', label: '60 Min' }
    ];

    const storageMessage = localStorage.getItem('messageNav');
    if (storageMessage) {
      this.message = JSON.parse(storageMessage);
    }

    this.cancelButtonTasK = {
      text: "Close",
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupTask = false;
      },
    };

    this.saveButtonTasK = {
      text: "Save",
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newtask.updateTask(false);
      },
    };

    this.saveNewButtonTasK = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(true)
      },

    };

    this.saveEditButtonTasK = {
      text: "Save & Edit ",
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(false, true)
      },
    };


    // if(localStorage.getItem('customerid') != undefined){
    // }


  }

  openCreateSalesProje() {
    this.popupCreateSalesProject = true;

    this.cancelButtonNewSales = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.componentSales.ngOnInit();
        this.popupCreateSalesProject = false;
      },
    };

    this.saveButtonNewSales = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.componentSales.updateSalesProject(1);
      },
    };

    this.saveNewButtonNewSales = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.componentSales.updateSalesProject(2);
      }
    };

    this.saveEditButtonNewSales = {
      text: this.translate.instant('btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.componentSales.updateSalesProject(3);
      }
    };
  }

  openAddCompany() {
    this.popupCustomer = true;

    this.cancelButtonNewCustomer = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupCustomer = false;
      },
    };

    this.saveButtonNewCustomer = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
    };

    this.saveNewButtonNewCustomer = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(false, false);
      },

    };

    this.saveEditButtonNewCustomer = {
      text: this.translate.instant('btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(true, true);
      },
    };
  }

  openAddEmpActivity() {
    this.popupEmployeeActivity = true;

    this.cancelButtonNewEmployee = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEmployeeActivity = false;
      },
    };

    this.saveButtonNewEmployee = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newActivity.submitForm(true, false);
      },
    };

    this.saveNewButtonNewEmployee = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newActivity.submitForm(false, false);
      },
    };

    this.saveEditButtonNewEmployee = {
      text: this.translate.instant('btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newActivity.submitForm(true, true);
      },
    };
  }

  getTemplatesEmail() {
    var mytoken = localStorage.getItem('token');

    if (mytoken) {
      this.MapInformationService.getEmailTemplate().subscribe(res => {
        let data = res
        let dataTemplate = []
        let titleTemplate = []
        Array.prototype.forEach.call(data, retorno => {
          let tempatePros = {
            id: retorno['ID'],
            active: retorno['ACTIVE'],
            createdate: retorno['CREATEDATE'],
            createbyid: retorno['CREATEBYID'],
            metadata: retorno['METADATA'],
            subject: retorno['SUBJECT'],
            tag: retorno['TAG'],
            text: retorno['TEXT'],
            updatedbyid: retorno['UPDATEDBYID'],
            updateddate: retorno['UPDATEDDATE'],
            key: 'Custom Template',
            method: 'InsertUpdateNotificationEmailTemplate'
          }
          dataTemplate.push(tempatePros)
        })
        Array.prototype.forEach.call(this.arrayTemplate, template => {
          if (template.key == 'Custom Template') {
            template.items = []
            template.items = dataTemplate
          }
        })
      })

    }

  }

  // ************ ALARMA (Parte del codigo agregado por Evander)*************************

  getAlarms() {
    // const data = {
    //   method: "Get_CompanyActiveAlarms"
    // }
    // this.MapInformationService.SaveInfoSites(data)
    //   .subscribe(resp => {
    //     resp.sort(function (a, b) { return a.Department_ID - b.Department_ID })

    //     this.TotalAlarms = resp.length
    //     this.PhasesAlarm = resp
    //   })

  }

  OpenPopupAlarm() {
    this.PopupAlarm = true
  }

  OpenPopupCompany() {
    this.PopupChangeCompany = true
  }
  showSendEmail: boolean = false;
  showEmailConfigPopup: boolean = false;

  OpenemailPopup() {
    // this.emailPopup = true

    const idUserConnected = localStorage.getItem('clienuser');
    this.MapInformationService.SaveInfoSites({ method: "Get_EMPLOYEE_EMAIL_CONNECTIONS", employeeid: idUserConnected })
      .subscribe(infoEmpleado => {
        console.log(infoEmpleado);
        if (infoEmpleado.length > 0) {
          this.emailPopup = true
        } else {
          this.emailPopup = false
          this.showEmailConfigPopup = true;
        }
      })
  }

  closeModalEmail() {
    this.emailPopup = false
  }

  redirectToMyInformation() {
    this.closeModalEmail();
    this.withShadingOptionsVisible = false;
    this.showEmailConfigPopup = false;
    this.router.navigate(['/myInformation']);
  }

  GoToAlarmModal(data) {
    switch (data.data.Alarm_Page) {
      case "Workflowsummary":
        this.enablePopupWorkFlowAlarm = true
        break
      case "Customer_Activities":
        this.enablePopupCompaniewAlarm = true
        break
    }
  }

  // ******************************************
  toggleSide() {
    this.isNavCollapse = !this.isNavCollapse;
    this.navCollapseOut.emit(this.isNavCollapse);
  }

  handleAddressChange(res) {
    this.userSetting.long = res.geometry.location.lng();
    this.userSetting.lat = res.geometry.location.lat();
    this.userSetting.geoname = res.formatted_address;
    localStorage.setItem('currentLat', res.geometry.location.lat().toString())
    localStorage.setItem('currentLong', res.geometry.location.lng().toString())
  }

  logOut() {
    let settings = localStorage.getItem('settings');
    sessionStorage.clear();
    localStorage.clear();
    this.userService.currentUserName.next('');
    this.router.navigateByUrl('/login');
    localStorage.setItem('settings', settings)
    this.isSideBarVisible = false
    this.dontShow = false
    this.showNavbarCommissioning = false
  }

  logOutCubeWorks() {
    let settings = localStorage.getItem('settings');
    sessionStorage.clear();
    localStorage.clear();
    this.userService.currentUserName.next('');
    this.router.navigateByUrl('/logincubeworks');
    localStorage.setItem('settings', settings)
  }

  toggleWithShadingOptions() {
    this.withShadingOptionsVisible = !this.withShadingOptionsVisible;
    if (localStorage.getItem("clientplanids")) {
      const planidsTempo = localStorage.getItem("clientplanids").split(",")

      console.log("🚀 ~ NavbarSidebarComponent ~ constructor ~ planidsTempo:", planidsTempo)
      this.planid = planidsTempo.find(planid => planid == "11") ? "11" : "0"
    }
  }

  limpiarmodalTask() {
    $('#btnlimpiarmodaltask').click();
  }

  onSubmitTask(visibleModal) {
    this.popupTask = visibleModal;
    // this.setGrid2();
  }

  saveUserSettings() {


    this.savingUserSetting = true;
    // this.userService.settings.value.moneyFormat = null;
    this.userService.settings.value.map = $('#txtmap').val();

    this.savingUserSetting = false;

    // this.userService.settings.value.regionid = null // comentar

    this.userSetting.usersettings = JSON.stringify(this.userService.settings.value);

    if (this.userService.settings.value.layout == "Horizontal") {
      localStorage.setItem('NavbarHorizontal', "Yes")
    } else {
      localStorage.setItem('NavbarHorizontal', "No")
    }



    this.userService.settings.value.lat = this.userSetting.lat
    this.userService.settings.value.long = this.userSetting.long

    let user = JSON.parse(this.userSetting.usersettings)
    user.lat = this.userSetting.lat;
    user.long = this.userSetting.long


    this.userSetting.usersettings = JSON.stringify(user)


    localStorage.setItem('settings', JSON.stringify(this.userService.settings.value));

    this.userService.saveUserSettingCoor(this.userSetting).subscribe(result => {
      this.toast.success(this.translate.instant('msgUpdSucc'));

      let languageid = JSON.parse(this.userSetting.usersettings).languageid;

      let language = this.languageSelect.find(x => x.value == languageid)

      if (language) {
        this.translate.use(language.traduction);
      }

      this.MapInformationService.SaveInfoSites({ method: "Update_EmployeeDafualDivision", regionid: this.userService.settings.value.regionid }).subscribe(result => {
        window.location.reload();
      });
    })

  }

  base64Logo: any = ""
  getMenu() {

    var mythis = this;

    this.data.currentMessage.subscribe(
      // message => this.message = message
      function name(message) {
        const storageMessage = localStorage.getItem('messageNav');

        if (storageMessage) {
          mythis.message = JSON.parse(storageMessage);
        } else {
          mythis.message = message;
        }
        // mythis.message = message;
        // localStorage.setItem('messageNav', JSON.stringify(message));

        const menu = localStorage.getItem('userMenu');
        if (!menu) {

          var mytoken = localStorage.getItem('token');

          if (mytoken) {

            mythis.userService.getMenu().subscribe((data) => {
              mythis.userNemu = data;
              localStorage.setItem('userMenu', JSON.stringify(data));

              mythis.menuDinamico = mythis.userNemu.userMenuNodes

              mythis.settingsImage.GetImgLogoPath().subscribe(result => {
                mythis.settingsImage.GetDocument(result[0].FILEPATH).subscribe(result2 => {
                  var data = result2.filestring.substring(0, 5);
                  let tipo = ""
                  switch (data.toUpperCase()) {
                    case "/9J/4": tipo = "jpeg";
                      break
                    default:
                      tipo = "png"
                      break
                  }

                  if (result2.filestring != '' && result2.filestring != undefined) {
                    mythis.base64Logo = 'data:image/' + tipo + ';base64,' + result2.filestring;
                  } else {
                    mythis.base64Logo = ''
                  }

                })

              });


              if (mythis.userNemu) {
                //
                //
                mythis.test(mythis.userNemu.userMenuNodes, mythis.currentUrl);
              }
            });

          }


        } else {
          mythis.userNemu = JSON.parse(menu);
          mythis.test(mythis.userNemu.userMenuNodes, mythis.currentUrl);
        }
        // setTimeout(() => {
        //   if (mythis.userNemu) {
        //
        //
        //     mythis.test(mythis.userNemu.userMenuNodes, mythis.currentUrl);
        //   }
        // }, 500);

      }
    )

    this.data.activeComponents.subscribe(
      // message => this.message = message
      function name(currentactiveComponents) {
        mythis.currentactiveComponents = currentactiveComponents;
      }
    )

    // this.data.currentUser.subscribe(
    //   function name(currentUserValue) {
    //       mythis.userName = currentUserValue;
    //   }
    // )

    // if (localStorage.hasOwnProperty('currentactiveComponents') == true){
    //   this.currentactiveComponents = JSON.parse(localStorage.getItem('currentactiveComponents'));
    //   this.currentMessageValue = JSON.parse(localStorage.getItem('currentMessageValue'));
    //   this.data.changeMessage3(this.currentactiveComponents, this.currentMessageValue);
    // }

  }

  setModuleId() {
    sessionStorage.setItem('moduleId', '0');
    sessionStorage.setItem('moduleName', '');
    this.generalService.moduleName.next('');
    this.router.navigateByUrl('/Training')
  }

  GoDashboard() {
    window.open(this.dashboardURL + "?uT=" + localStorage.getItem('token'), '_blank');
  }

  cancel() {
    this.modelChangePassword = {
      pass: '',
      confirmPass: ''
    };
  }


  changePass() {
    this.userService.changePassword(this.modelChangePassword.pass).subscribe(result => {

      if (result.response == 0) {
        this.toast.success(this.translate.instant('msgPwdChagSucc'));
      }
    });
  }

  GoToZD() {
    this.userService.getZDUserToken().subscribe(result => {
      window.open("https://cube-usa-edge.zendesk.com/access/jwt?jwt=" + result.ztoken, "_blank");
    });
  }

  test(array: any, link: string, resetbreadcrum = true, parentModule = {}) {
    if (resetbreadcrum) {
      this.generalService.breadcrum.next([]);
    }

    let finalLink = link.split('?')[0];

    for (let index = 0; index < array.length; index++) {
      const element = array[index];

      if (element.cubeLink == finalLink) {
        this.updateBreadCrum(parentModule);
        this.updateBreadCrum(element);
        sessionStorage.setItem('moduleId', element.id);
        this.generalService.moduleName.next(element.moduleName);

        return true;
      } else {
        if (element.userModules.length > 0) {
          // this.updateBreadCrum(element.moduleName);

          const stop = this.test(element.userModules, finalLink, false, element);

          if (stop == true) {
            return;
          }
        }
      }
    }
    return false;
  }

  updateBreadCrum(item: any) {
    const currentValue = this.generalService.breadcrum.value;
    const updatedValue = [...currentValue, item];
    this.generalService.breadcrum.next(updatedValue);
  }

  callModule(item: any) {
    sessionStorage.setItem('moduleId', item.id);
    sessionStorage.setItem('moduleName', item.moduleName);
    this.generalService.moduleName.next(item.moduleName);
    this.data.changeMessage({ id: item.id, moduleName: item.moduleName, cubeLink: item.cubeLink });

    this.router.navigateByUrl(item.cubeLink);
    $("#AB1").collapse("show");
  }

  deleteModule(item: any) {
    this.data.changeMessage2(item.id, item.cubeLink);
    this.router.navigate([this.currentactiveComponents[this.currentactiveComponents.length - 1]]);
  }

  mdSettings2() {
    this.popupSettings2 = true;
  }

  AccepTerms() {
    this.userService.acceptTerms(localStorage.getItem('email').toString()).subscribe(result => {
      localStorage.setItem('termaccepted', "1");
      window.location.reload();
    });
  }

  getMenuTop() {
    return -200
  }

  goToHome() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl('/home');
  }

  asignarValue(event, input) {
    this.template[input] = event.value
  }

  deleteUpdateTemplate() {
    let eliminarObject: boolean
    eliminarObject = false
    Array.prototype.forEach.call(this.arrayTemplate, template => {
      if (template.key == "Update Templates") {
        eliminarObject = true
      }
      if (eliminarObject == true) {
        this.arrayTemplate.splice(1, 1)
      }
    })
  }

  saveTemplate(comportamiento) {
    let eliminarObject: boolean
    eliminarObject = false
    this.template['key'] = ''
    this.MapInformationService.insertUpdateEmailTemplate(this.template).subscribe(res => {
      Array.prototype.forEach.call(this.arrayTemplate, (template, i) => {
        if (template.key == "Update Templates") {
          eliminarObject = true
        }
        else if (template.key == "Custom Template") {
          if (comportamiento == 'update') {
            Array.prototype.forEach.call(template.items, item => {
              if (this.template.id == item.id) {
                item['key'] = "Custom Template"
                item['subject'] = this.template.subject
                item['text'] = this.template.text
              }
            })
          } else if (comportamiento == 'new') {
            this.MapInformationService.getEmailTemplate().subscribe((res: Array<any>) => {
              let templates = res
              let numTemplate = res.length
              let templateNew = templates[numTemplate - 1]
              let tempatePros = {
                id: templateNew['ID'],
                active: templateNew['ACTIVE'],
                createdate: templateNew['CREATEDATE'],
                createbyid: templateNew['CREATEBYID'],
                metadata: templateNew['METADATA'],
                subject: templateNew['SUBJECT'],
                tag: templateNew['TAG'],
                text: templateNew['TEXT'],
                updatedbyid: templateNew['UPDATEDBYID'],
                updateddate: templateNew['UPDATEDDATE'],
                key: 'Custom Template',
                method: 'InsertUpdateNotificationEmailTemplate'
              }
              template.items.push(tempatePros)
              let nuevosTemplates = template.items
              this.arrayTemplate[i].items = nuevosTemplates
            })
          }
        }
      })
      if (eliminarObject == true) {
        this.arrayTemplate.splice(1, 1)
      }
      // this.emailPopup = false;
      // this.popupVisibleTemplates = false;
      this.clearTemplate()
      // this.getTemplatesEmail()
      this.toast.success(this.translate.instant('msgTempUpdSucc'));
    })
  }

  selectTemplate(item) {
    this.popupVisibleTemplates = false;
    this.template = item;
    let update =
    {
      key: 'Update Templates',
      items: [{ subject: 'Update template' }],
    }
    let agregar: Boolean
    agregar = true
    Array.prototype.forEach.call(this.arrayTemplate, template => {
      if (template.key == "Update Templates") {
        agregar = false
      }
    })
    if (agregar == true) {
      this.arrayTemplate.splice(1, 0, update)
    }
  }

  onItemDeleting(event) {
  }

  onItemDeleted(event) {
  }

  clearTemplate() {
    this.template = {
      id: 0,
      text: '',
      active: 1,
      subject: '',
      createdate: '',
      updateddate: '',
      updatedbyid: '',
      tag: '',
      metadata: '',
      method: 'InsertUpdateNotificationEmailTemplate'
    }
  }

  modalChatboxOPENAINewWindows() {
    try {
      // Guarda una marca con timestamp (por seguridad)
      const payload = { ts: Date.now() };
      localStorage.setItem('OpenModalNextTime', JSON.stringify(payload));

      // Obtiene la URL base actual (sin el route)
      const baseUrl = window.location.origin;
      // Construye la nueva URL con el route deseado
      const newUrl = `${baseUrl}/#/botChat`;

      // Abre en nueva pestaña
      const newWin = window.open(newUrl, '_blank');

      // Manejar bloqueador de popups
      if (!newWin) {
        console.warn('Popup bloqueado por el navegador');
      }
    } catch (e) {
      console.error('No se pudo abrir nueva pestaña:', e);
    }
  }

  modalChatboxOPENAI() {
    this.MapInformationService
      .SaveInfoSites({ method: 'Get_Bot_UserHistoryChat', threadid: this.threadid })
      .subscribe({
        next: (result: any) => {


          this.popupChatbox = true;

          // 1) Si el servicio devuelve un array vacío: [] → saludo por defecto
          if (Array.isArray(result) && result.length === 0) {
            this.messages = [this.createDefaultMessage()];
            return;
          }

          // 2) Si devuelve un array con un objeto que contiene MESSAGES (string con JSON.stringify)
          //    También cubrimos el caso raro donde venga como objeto directo.
          let rawMessages: any = null;
          if (Array.isArray(result) && result.length > 0 && 'MESSAGES' in result[0]) {
            rawMessages = result[0].MESSAGES;
          } else if (result && typeof result === 'object' && 'MESSAGES' in result) {
            rawMessages = result.MESSAGES;
          }

          // Parse seguro
          if (typeof rawMessages === 'string' && rawMessages.trim().length > 0) {
            try {
              const parsed = JSON.parse(rawMessages);

              // Si parsed es un array con mensajes, úsalo; si no, saludo por defecto
              if (Array.isArray(parsed) && parsed.length > 0) {
                this.messages = parsed;
              } else {
                this.messages = [this.createDefaultMessage()];
              }
            } catch {
              this.messages = [this.createDefaultMessage()];
            }
          } else {
            // Si MESSAGES no existe, viene vacío o no es string válido → saludo por defecto
            this.messages = [this.createDefaultMessage()];
          }


        },
        error: (err) => {
          console.error('Error cargando historial:', err);
          this.popupChatbox = true;
          this.messages = [this.createDefaultMessage()];
        }
      });
  }

  // Opcional: método helper en tu componente para no repetir el objeto
  private createDefaultMessage() {
    return {
      author: 'Assistant',
      authorName: 'Cubic',
      text: "Hello I'm Cubic, how can I help you ?",
      time: new Date().toLocaleTimeString()
    };
  }




  modalChatbox() {


    this.openAI = true;

    this.userService.Get_UserSettingsCE(localStorage.getItem('customerid')).subscribe(result => {

      if (result.length > 0 && result[0].CLIENTUSERSETTING) {
        let obj = JSON.parse(result[0].CLIENTUSERSETTING);

        localStorage.setItem('showbotintro', result[0].SHOWBOTINTRO);

        const showBotIntroString = localStorage.getItem('showbotintro');
        const showBotIntro = showBotIntroString === 'true';

        if (showBotIntro !== null && showBotIntro == false) {
          this.skipIntroduction = true;
        }
        else {
          this.skipIntroduction = false;
        }

        // alert(showBotIntro);

        this.appUser = localStorage.getItem('botmessages');

        if (!(localStorage.getItem('openai'))) {
          const currentUrl = window.location.href;
          window.open(currentUrl, '_blank');
          localStorage.setItem('openai', 'true');
          return
        }

        this.popupChatbox = true;

        this.messages = [];

        const storedMessages = localStorage.getItem('botmessages');
        if (storedMessages) {
          //this.messages = JSON.parse(storedMessages);
          this.messages.push({
            author: 'Virtual Assistant',
            text: "Welcome back " + localStorage.getItem('userName'),
            time: 'Just now',
            authorName: 'Virtual Assistant'
          });
        }
        else {
          if (this.skipIntroduction == false) {
            this.messagescopy = [];

            // this.respondToMessage('What can you do?');

            this.messages.push({
              author: 'Virtual Assistant',
              text: 'Hello ' + localStorage.getItem('userName') + ' How can i help you?',
              time: 'Just now',
              authorName: 'Virtual Assistant'
            });

            localStorage.setItem('botmessages', JSON.stringify(this.messages));

          }
        }

        // this.messages.push({
        //   author: 'Virtual Assistant',
        //   text: 'How can I assist you? For example, you could ask, "How do I create an estimate?"',
        //   time: 'Just now',
        //   authorName: 'Virtual Assistant'
        // });                

        localStorage.removeItem('openai');

      }
    });


  };

  buttonData = [
    { title: 'HELP AND SUPPORT', action: 'USER_HELP' },
    { title: 'VIRTUAL ASSISTANT', action: 'USER_ACTION' },
    { title: 'DATA ANALYST', action: 'DATA_ANALYST' }
  ];

  onButtonClick(title: string, action: string, index: number) {
    this.clickedButtonIndex = index;
    var messagesupport = '';
    if (index == 0) {
      messagesupport = 'How can I assist you? For example, you could ask, "How do I create an estimate?"';
    } else if (index == 1) {
      messagesupport = 'How can I assist you? For example, you could ask, "Create an estimate with this project name."';
    } else if (index == 2) {
      messagesupport = 'How can I assist you? For example, you could ask, "Analyze monthly sales."';
    } else {
      messagesupport = 'How can I assist you? For example, you could ask about anything related to control engineering, "Is there a Visio Add-In for Control Engineering?"';
    }
    this.messages.push({
      author: 'Virtual Assistant',
      text: messagesupport,
      time: 'Just now',
      authorName: 'Virtual Assistant'
    });
    // if (action == 'VRTUALASSISTANT'){
    //   this.buttonData = [
    //     { title: 'CREATE AN ESTIMATE WITH NEW PROJECT NAME', action: 'Create an estimate with this new project name: ' },
    //     { title: 'HOME', action: 'HOME' }
    //   ];
    // }
    // else if (action == 'DATAANALYST'){
    //   this.buttonData = [
    //     { title: 'CONTROL ENGENIERING PROBLEM AND RESOLUTION', action: 'I need help about cube edge with: ' },
    //     { title: 'HOME', action: 'HOME' }
    //   ];
    // }
    // else if (action == 'HOME'){
    //   this.buttonData = [
    //     { title: 'HELP AND SUPPORT', action: 'I need help about cube edge with: ' },
    //     { title: 'VIRTUAL ASSISTANT', action: 'VRTUALASSISTANT' },
    //     { title: 'DATA ANALYST', action: 'DATAANALYST' }
    //   ];
    // }
    // else {
    //   this.userInput = action;
    // }
  }

  addTask() {
    this.popupTask = true;
    this.withShadingOptionsVisible = false;
    // if(this.newtask.primeraVez == true){
    //   this.newtask.setDefaultSettings();
    // }
  }

  NavCubeWorks(to) {
    this.router.navigate([`/${to}`])
    // this.isActive = !this.isActive;
  }

  // Method to handle the config change
  handleConfigChange() {
    let settings = {
      dateFormat: this.appSettings.appConfig.dateFormat,
      moneyFormat: this.appSettings.appConfig.moneyFormat,
      layout: this.appSettings.appConfig.layout,
      startPage: ''
    }
    this.LinkGettingStarted = this.appSettings.appConfig.LinkGettingStarted;
    this.LinkCubeFlow = this.appSettings.appConfig.LinkCubeFlow;
    this.LinkWhatsNew = this.appSettings.appConfig.LinkWhatsNew;
    this.dashboardURL = this.appSettings.appConfig.dashboardURL;

    this.userService.settings.next(settings);

  }


  // showNewEstimate() {
  //   this.initformAndSelect()
  //   this.initForm()
  //   this.popupNewEstimateQuick = true
  // }

  showNewEstimate() {

    // this.showModalMonto = true
    // this.popupInsufficientCredits = true



    if (this.planid == "11") {
      this.MapInformationService.SaveInfoSites({
        method: "GetClientCubeShopCredit",
      }).subscribe(resp => {
        if (resp[0].credit) {

          if (resp[0].credit > 50) {

            this.currentBalance = resp[0].credit
            this.remainingBalance = this.currentBalance - this.estimateCost
            this.initformAndSelect()
            this.initForm()

            this.popupNewEstimateQuick = true

          } else {
            this.popupInsufficientCredits = true
          }

        } else {
          this.popupInsufficientCredits = true
        }
      })

    } else {
      this.initformAndSelect()
      this.initForm()


      this.popupNewEstimateQuick = true

    }
  }


  closePopupSelectNew() {
    // this.popupNewEstimateQuick = false;
    this.searchProject.instance.repaint()
    this.searchProject.instance.reset()

    if (this.searchProject != null) {
      this.searchProject.placeholder = "Search existing CUBE CRM projects, or click (+) to create a new one"
    }

  }
  


  initForm() {
    this.firstFormGroup = new FormGroup({
      projectid: new FormControl('', [Validators.required]),
      projectname: new FormControl('', [Validators.required]),
      projectnameTemp: new FormControl('', [Validators.required]),
    });
  }

  initformAndSelect() {

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        // return mythis.taskService.GetProjectByName(loadOptions.searchValue)
        return mythis.ProjectService.Get_All_SalesProjectsByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  updateProjectInfo(obj) {
    if (obj.selectedItem) {
      this.firstFormGroup.get('projectname').setValue(obj.selectedItem.Project_Name);
      this.firstFormGroup.get('projectid').setValue(obj.selectedItem.ID);
      this.firstFormGroup.get('projectnameTemp').setValue(obj.selectedItem.Project_Name);
    } else {
      this.firstFormGroup.get('projectname').setValue(null);
      this.firstFormGroup.get('projectid').setValue(null);
    }
  }

  modalItem(chat: any, obj: any) {
    this.threadid = chat.threadid.toString();
    this.confirmDeletePopup = true;
  }

  deleteItem(chat: any, obj: any) {
    this.MapInformationService.SaveInfoSites({ 'method': 'Bot_inactiveOldChatsByUser', threadid: this.threadid.toString() }).subscribe(result => {
      this.Bot_getOldChatsByUser();
      this.confirmDeletePopup = false;
    });
  }

  handleQuickReply(qr: any, e: any) {
    this.userInput = qr.title;
    this.sendMessageOPENAI();
  }


  searchQuickReplies() {
    this.MapInformationService.SaveInfoSites({ 'method': 'GetCubeOpenAIQuestionByType', topic: 'BOT_REPLYS_USER_OPTIONS' }).subscribe(result => {
      let userPromptTemplate = result[0].USERPROMPT.toString();
      let systemPromptTemplate = result[0].SYSTEMPROMPT.toString();

      let body = {
        systemPrompt: userPromptTemplate,
        userprompt: systemPromptTemplate,
        utoken: localStorage.getItem('token'),
        threadid: this.threadid.toString()
      }

      this.MapInformationService.queryHelpAssitant(body).subscribe(result => {
        const quickRepliesArray = JSON.parse(result.response);

        if (this.messages.length > 0) {
          this.messages[this.messages.length - 1].quickReplies = quickRepliesArray;
          console.log(this.messages);
          console.log(result);
        } else {
          console.warn('No hay elementos en this.messages para agregar quickReplies');
        }

      });


    });
  }


  changeChatName() {
    if (this.messages.length == 3) {
      this.MapInformationService.SaveInfoSites({ 'method': 'GetCubeOpenAIQuestionByType', topic: 'BOT_CHATNAME' }).subscribe(result => {
        let userPromptTemplate = result[0].USERPROMPT.toString();
        // Sustituir la variable {{USERQUESTION}} en el prompt
        let userPrompt = userPromptTemplate.replace('{{USERQUESTION}}', this.lastUserInput || '');

        let prompt = {
          systemPrompt: result[0].SYSTEMPROMPT.toString(),
          userprompt: userPrompt
        };

        this.MapInformationService.SearchCubeAI(prompt).subscribe(response => {
          this.MapInformationService.SaveInfoSites({
            'method': 'Bot_UpdateChatName',
            threadid: this.threadid.toString(),
            chatname: response.content.toString()
          }).subscribe(() => {
            this.Bot_getOldChatsByUser();
          });
        });
      });
    }

  }



  // createProject() {
  //   if (this.projectName != undefined) {
  //     let info =
  //     {
  //       "bidreqdate": "",
  //       "biddate": "",
  //       "projectid": 0,
  //       "projectnum": null,
  //       "name": this.projectName,
  //       "siteid": 0,
  //       "salescategoryid": 1,
  //       "bidstatus": 1,
  //       "closedate": "",
  //       "amount": 0,
  //       "profit": 0,
  //       "profitpercent": 0,
  //       "consultingid": 0,
  //       "salesemp": 0,
  //       "custreqpriceid": 0,
  //       "custawardprojectid": 0,
  //       "projectverticalid": 1,
  //       "awardedto": 0,
  //       "productspecified": 0,
  //       "partestimaterequestbyid": 0,
  //       "prevailingwagecode": 0,
  //       "notbidreason": 0,
  //       "salescomment": "",
  //       "salesnotes": "",
  //       "address": "",
  //       "addressline2": "",
  //       "city": "",
  //       "state": "",
  //       "country": "",
  //       "zip": "",
  //       "lat": 0,
  //       "lon": 0,
  //       "prevailingwage": 0,
  //       "method": "InsertUpdate_SalesProjectsCE"
  //     }

  //     this.MapInformationService.SaveInfoSites(info)
  //       .subscribe(resp => {


  //         this.firstFormGroup.get('projectid').setValue(resp[0].ReturnID);
  //         this.firstFormGroup.get('projectname').setValue(this.projectName);
  //         this.firstFormGroup.get('projectnameTemp').setValue(this.projectName);
  //         this.searchProject.placeholder = resp[0].ReturnID + " " + this.projectName

  //         this.toast.success("Project created successfully")
  //         this.projectName = ''
  //         this.popupCreateSalesProject2 = false
  //         this.initformAndSelect()
  //       })
  //   } else {
  //     this.toast.warning("You must write a name")
  //   }
  // }

  // createEstimate() {
  //   let dataFinal = this.firstFormGroup.value
  //   const currentuserid = localStorage.getItem("customerid");
  //   let project = this.firstFormGroup.value;
  //   this.estimateService.InsertEstimateWithTax(
  //     dataFinal.projectid,
  //     0,
  //     0,
  //     0,
  //     0,
  //     0,
  //     currentuserid,
  //     0,
  //     0,
  //   ).subscribe(result => {
  //     if (result[0]) {
  //       let estimateid = result[0].ID;
  //       this.estimateService
  //         .Insert_EstimateAreaCE(estimateid, 'Area 1', 0, 1, true)
  //         .subscribe((area) => {
  //           if (area[0]) {
  //             this.popupNewEstimateQuick = false
  //             this.popupCreateSalesProject2 = false
  //             let url = `/Estimates/editEstimate?numESTIMATEID=${estimateid}&strPROJECT_NAME=${dataFinal.projectid + "-" + project.projectname}&numProjectID=${project.projectid}`
  //             this.toast.success(this.translate.instant('msgEstCreSucc'));
  //             this.initformAndSelect()
  //             this.initForm()
  //             this.projectName = ''
  //             this.router.navigateByUrl(url)
  //           }
  //         });
  //     }
  //   })
  // }

  showLinksOrURL(data) {
    if (data.cubeLink == "NULL") {
      this.router.navigateByUrl(`/CUBEcx?moduleName=${data.moduleName}`);
    } else {
      this.router.navigateByUrl(data.cubeLink);
    }
  }

  goToDashboard() {
    this.router.navigateByUrl("/dashboard");
  }

  showHelpCards() {
    this.router.navigateByUrl(`/CUBEcx?moduleName=Help`);
  }

  sendMessage() {
    if (this.userInput.trim()) {
      this.messages.push({
        author: 'User',
        text: this.userInput,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });
      this.respondToMessage('');
      this.userInput = '';
    }
  }



  sendMessageOPENAI() {

    if (this.userInput.trim()) {
      this.messages.push({
        author: 'User',
        text: this.userInput,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });
    }

    let body = {
      systemPrompt: "You are the official help assistant for the CUBE application. Always respond in clear and concise English. Use only the information contained in the attached help file.",
      userprompt: this.userInput,
      utoken: localStorage.getItem('token'),
      threadid: this.threadid.toString()
    }

    this.lastUserInput = this.userInput;

    this.userInput = '';

    this.MapInformationService.queryHelpAssitant(body).subscribe(result => {

      this.threadid = result.thread_id.toString();

      this.messages.push({
        author: 'Virtual Assistant',
        text: result.response.toString(),
        time: 'Just now',
        authorName: 'Virtual Assistant'
      });

      this.MapInformationService.SaveInfoSites({ 'method': 'Save_Bot_UserHistoryChat', messages: JSON.stringify(this.messages), threadid: this.threadid.toString() }).subscribe(result => {
        this.changeChatName();
        this.searchQuickReplies();
      });
    });

  }



  clearChat() {
    this.threadid = "";
    this.userInput = '';
    this.messages = [];
    this.messages = [this.createDefaultMessage()];
  }

  openAInewChat() {
    this.clearChat();
  }

  selectChat(itemData: any) {
    console.log(itemData);
    this.clearChat();
    this.threadid = itemData.threadid;
    this.modalChatboxOPENAI();
  }

  toggleRecording() {
    if (this.isRecording == false) {
      this.service.start();
      this.isRecording = true;
    }
    else {
      this.service.stop();
      this.isRecording = false;
      this.userInput = this.service.text;
      this.messages.push({
        author: 'User',
        text: this.userInput,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });
      this.respondToMessage('');
      this.userInput = '';
    }
  }

  resetPopup() {
    this.popupChatbox = false;
    this.messages = [];
  }

  stopVoice() {
    this.isButtonDisabled = true;
    this.textToVoiceService.stop();
  }

  respondToMessage(msg: string) {


    var soloMsg = '';

    var themessages = JSON.stringify(this.messages);

    if (msg != '') {

      this.messagescopy = [];

      this.messagescopy.push({
        author: localStorage.getItem('userName'),
        text: msg,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });

      themessages = JSON.stringify(this.messagescopy);

      soloMsg = msg;

    }
    else {
      if (this.messages.length != 0) {
        soloMsg = this.messages[this.messages.length - 1].text
      }
    }

    // if (msg != ''){ themessages = msg  }

    const currentURL = document.location.origin + document.location.pathname;
    const encodedURL = encodeURIComponent(currentURL);


    this.userService.getcubechatResponse({ base64: "", textPrompt: themessages, usToken: localStorage.getItem('token'), currentURL: encodedURL, solotextPrompt: soloMsg, usercurrenttopic: this.buttonData[this.clickedButtonIndex].action }).subscribe(result => {
      this.textToVoiceService.speak(result);
      this.isButtonDisabled = false;
      this.messages.push({
        author: 'Virtual Assistant',
        text: result,
        time: 'Just now',
        authorName: 'Virtual Assistant'
      });
      localStorage.setItem('botmessages', JSON.stringify(this.messages));
      // this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight; 
      // alert('Hola'); 
    });


  }

  onSkipIntroductionChanged(event: any) {
    //   var valorsave = 0;
    //   if (this.skipIntroduction == true) {
    //     localStorage.setItem('showbotintro', 'false');
    //     valorsave = 0;
    //   }
    //   else {
    //     localStorage.setItem('showbotintro', 'true');
    //     valorsave = 1;
    //   }
    //   // if(this.name != 'CompanyRegistration'){
    //   this.userService.updateuserSetting({ method: "Update_UserSettingsCEShowBotIntro", showbotintro: valorsave }).subscribe(result => {
    //   });
    // // }
    // this.openAI = false;
  }


  GotoEstimate() {
    const estimateIDSelected = localStorage.getItem("estimateIDSelected")
    const estimatenamestrSelected = localStorage.getItem("estimatenamestrSelected")
    const projectIDSelected = localStorage.getItem("projectIDSelected")

    if (estimateIDSelected == undefined) {
      this.router.navigate(['/home']);
    } else {
      if (localStorage.getItem("fromCommissioning") == 'Yes') {
        this.router.navigate(['/commissioning/techView'], { queryParams: { numID: estimateIDSelected, numProjectID: projectIDSelected, strPROJECT_NAME: estimatenamestrSelected } });
      } else {
        this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: estimateIDSelected, numProjectID: projectIDSelected, strPROJECT_NAME: estimatenamestrSelected } });
      }
    }
  }

  goHome() {
    if (this.clientplanid != 10) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/applications']);
    }
  }

  PreviousPage() {
    this.location.back()
  }

  NavCubeShop(to) {
    this.router.navigate([`/${to}`])
  }

  showFiltersAI() {
    this.componentModel = {
      COMPSCOPE: "",
      COMPSCOPEWITHOUTHTML: "",
      ID: 0,
      NAME: "",
      SystemType: "",
      TypeId: [],
      Image: 'Not_Image',
      VisionComponentName: '',
      Path: '',
      filename: '',
      ACHR: '',
      tagid: [],
      tagParent: 0,
      typeImage: "",
      notshowiddwg: false,
      applicationtypeid: [],
      notschematic: false
    };
    this.showFiltersAIModal = true
    this.getTagParents()
  }

  showFiltersModal: boolean = false
  showFiltersAIModal: boolean = false
  filterNew: FormGroup
  showFilters() {
    this.componentModel = {
      COMPSCOPE: "",
      COMPSCOPEWITHOUTHTML: "",
      ID: 0,
      NAME: "",
      SystemType: "",
      TypeId: [],
      Image: 'Not_Image',
      VisionComponentName: '',
      Path: '',
      filename: '',
      ACHR: '',
      tagid: [],
      tagParent: 0,
      typeImage: "",
      notshowiddwg: false,
      applicationtypeid: [],
      notschematic: false
    };
    this.showFiltersModal = true
    this.getTagParents()
  }

  tagsParens: any[] = []
  taggingDatasource: any[] = []
  componentModel = {
    COMPSCOPE: "",
    COMPSCOPEWITHOUTHTML: "",
    ID: 0,
    NAME: "",
    SystemType: "",
    TypeId: [],
    Image: 'Not_Image',
    VisionComponentName: '',
    Path: '',
    filename: '',
    ACHR: '',
    tagid: [],
    tagParent: 0,
    typeImage: "",
    notshowiddwg: false,
    applicationtypeid: [],
    notschematic: false
  };

  systemTypeSelectCE: any[] = []

  getTagParents() {
    this.MapInformationService.SaveInfoSites({ method: "Get_EcomEstimateSytemTypeCEWithoutFirstParent" })
      .subscribe(resp => {
        this.systemTypeSelectCE = resp
      })

    // this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
    //   this.systemTypeSelectCE = result;
    // });
  }

  Bot_getOldChatsByUser() {
    this.MapInformationService
      .SaveInfoSites({ method: 'Bot_getOldChatsByUser' })
      .subscribe((resp: any[]) => {
        const nowIso = new Date().toISOString();

        this.unpinnedChats = (resp || [])
          .filter(r => !!r.ThreadId) // sólo válidos
          .map<ChatSummary>(r => {
            const d = r.ChatDate ? new Date(r.ChatDate) : null;
            const when = d && !isNaN(d.getTime()) ? d.toISOString() : nowIso;

            return {
              // Usamos el ThreadId como clave única estable (también lo guardamos en threadid)
              id: String(r.ThreadId),
              title: (r.ChatName && r.ChatName.trim()) || `Chat ${r.ID}`,
              createdAt: when,
              updatedAt: when,
              threadid: String(r.ThreadId),
              pinned: false
            };
          })
          // opcional: ordena por lo más reciente
          .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
      }, err => {
        console.error('Error cargando chats', err);
        this.unpinnedChats = [];
      });
  }

  changeSegmentParents(e) {
    this.getTagging(e.selectedItem.ID)
  }

  // getTagging(id) {
  //   this.MapInformationService.SaveInfoSites({ 'method': 'Get_TagEngUtilityByParentID', parentid:id}).subscribe(result => {
  //     this.taggingDatasource = result;
  //   });
  // }


  getTagging(id) {
    this.MapInformationService.SaveInfoSites({ 'method': 'Get_EcomComponentsTreeFilter', id: id }).subscribe(result => {
      this.taggingDatasource = result;
    });
  }





  searchData() {

    const idsTags = this.componentModel.tagid.join(",")
    const idMastertype = this.componentModel.tagParent


    this.showFiltersModal = false
    this.clearFilterIndividual('Clear')

    this.router.navigate(['/Applicationfiltered'], { queryParams: { idMaster: idMastertype, componentids: idsTags } });
    if (this.dataMenuNavbar == "Applicationfiltered") {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }


  }

  searchDataAI() {

    const idMastertype = this.componentModel.tagParent


    this.showFiltersAIModal = false;
    this.clearFilterIndividual('Clear')

    this.router.navigate(['/AIShop'], { queryParams: { idType: idMastertype } });

  }

  closeParentsSystemType() {
    this.treeviewTag.instance.collapseAll()
  }

  OpenParentsSystemType() {
    this.treeviewTag.instance.expandAll()
  }


  closeParentsComponentType() {
    this.treeviewType.instance.collapseAll()
  }

  OpenParentsComponentType() {
    this.treeviewType.instance.expandAll()
  }

  groupItemsFilter: any[] = []
  typeDatasource: any[] = []
  openFilterParents() {

    this.estimateService.Get_EstimateLibComponentsTreeCE2().subscribe(result => {
      this.groupItemsFilter = result
    });

    this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      this.typeDatasource = result;
    });
  }

  typeids: any[] = []
  treeBoxValue2: string[] = [];
  notAllowed: boolean = false
  FirtsTime: boolean = true




  clearFilterIndividual(typeOfClear) {
    switch (typeOfClear) {
      case 'System Type':
        this.typeids = []
        this.treeBoxValue2 = []
        if (this.treeBoxTags != undefined) {
          this.treeBoxTags.instance.reset()
        }

        if (this.treeviewTag != undefined) {
          this.treeviewTag.instance.unselectAll()
        }

        this.filterNew.get("systemtypeID").setValue("")

        break
      case 'Component Type':
        this.categorySelected = []
        this.treeBoxValue = []
        if (this.treeBoxType != undefined) {
          this.treeBoxType.instance.reset()
        }
        if (this.treeviewType != undefined) {
          this.treeviewType.instance.unselectAll()
        }
        this.filterNew.get("componentType").setValue("")
        break
      default:
        this.clearDataAll()
        break
    }
  }

  clearDataAll() {
    this.typeids = []
    this.treeBoxValue2 = []
    this.showFiltersAIModal = false
    if (this.treeBoxTags != undefined) {
      this.treeBoxTags.instance.reset()
    }

    if (this.treeviewTag != undefined) {
      this.treeviewTag.instance.unselectAll()
    }

    if (this.filterNew != undefined) {
      this.filterNew.get("systemtypeID").setValue("")
    }
    // *******************************************************
    this.categorySelected = []
    this.treeBoxValue = []
    if (this.treeBoxType != undefined) {
      this.treeBoxType.instance.reset()
    }
    if (this.treeviewType != undefined) {
      this.treeviewType.instance.unselectAll()
    }
    if (this.filterNew != undefined) {
      this.filterNew.get("componentType").setValue("")
    }
  }








  categorySelected: any[] = []
  treeBoxValue: string[];

  syncTreeViewSelection(e) {
    var component =
      (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (!this.treeBoxValue) {
      component.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }
  }

  treeView_itemSelectionChanged(e) {
    // Si es la primera vez que se selecciona algo, realizar la misma operación
    if (e.itemElement !== undefined) {

      this.componentModel.tagParent = e.component.getSelectedNodeKeys();
      this.treeBoxValue = e.component.getSelectedNodeKeys();
      this.FirtsTime = false;
      this.getTagging(e.itemData.ID)

    }
  }




  syncTreeViewSelection2(e) {
    var component = (e && e.component) || (this.treeView2 && this.treeView2.instance);

    if (!component) return;

    // Desmarcar todos los elementos si no hay valores seleccionados
    if (!this.treeBoxValue2 || this.treeBoxValue2.length === 0) {
      component.unselectAll();
    } else {
      // Asegurarse de que solo se seleccionen los elementos presentes en treeBoxValue2
      component.unselectAll(); // Limpiar selección previa

      this.treeBoxValue2.forEach(function (value) {
        component.selectItem(value); // Seleccionar cada valor
      });
    }
  }

  treeView_itemSelectionChanged2(e) {

    // Si es la primera vez que se selecciona algo, realizar la misma operación
    if (e.itemElement !== undefined) {
      this.componentModel.tagid = e.component.getSelectedNodeKeys();
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
      this.FirtsTime = false;
    }
  }


  // Shop


  goToCubeShop() {

    localStorage.removeItem("estimateIDSelected")
    localStorage.removeItem("estimatenamestrSelected")
    localStorage.removeItem("projectIDSelected")
    localStorage.removeItem('CreateInAEstimate');
    localStorage.removeItem("fromCommissioning")

    this.showPopupShop = false

    let url = window.location.href.split("#");
    let finalUrl = `${url[0]}#/applications`;
    window.open(finalUrl, "_blank");

  }

  showPopupShop: boolean = false
  estimatename = "";
  estimatenamestr = "";
  estimateDataSourceSelect: CustomStore;
  goToShop: boolean = false
  estimateSelectedShop: any

  ShowModalShop() {
    this.showPopupShop = true
    this.getEstimateSelect()
  }

  updateEstimate(item) {
    if (item.selectedItem) {

    }
  }

  getEstimateSelect() {
    let mythis = this
    this.estimateDataSourceSelect = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.estimateService.Get_EstimateListNavAll(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }


  goToNewEstimateShop() {
    this.goToShop = true
    this.initformAndSelect()
    this.initForm()

    this.popupNewEstimateQuick = true
  }

  updateEstimateSelected(obj) {
    if (obj.selectedItem) {
      this.estimateSelectedShop = obj.selectedItem
    }
  }

  // initformAndSelect(){

  //   let mythis = this;
  //   this.projectslist = new CustomStore({
  //     key: "ID",
  //     load: function (loadOptions: any) {
  //       // return mythis.taskService.GetProjectByName(loadOptions.searchValue)
  //       return mythis.ProjectService.Get_All_SalesProjectsByName(loadOptions.searchValue)
  //         .toPromise()
  //         .then((data: any) => {
  //           return data;
  //         })
  //         .catch(error => { throw 'Data Loading Error' });
  //     }
  //   });
  // }



  // createEstimate() {
  //   let dataFinal = this.firstFormGroup.value
  //   const currentuserid = localStorage.getItem("customerid");
  //   let project = this.firstFormGroup.value;
  //   this.estimateService.InsertEstimateWithTax(
  //     dataFinal.projectid,
  //     0,
  //     0,
  //     0,
  //     0,
  //     0,
  //     currentuserid,
  //     0,
  //     0,
  //   ).subscribe(result => {
  //     if (result[0]) {
  //       let estimateid = result[0].ID;
  //       this.estimateService
  //         .Insert_EstimateAreaCE(estimateid, 'Area 1', 0, 1, true)
  //         .subscribe((area) => {
  //           if (area[0]) {

  //             if (this.goToShop) {
  //               localStorage.setItem("estimateIDSelected", estimateid.toString())
  //               localStorage.setItem("estimatenamestrSelected", project.projectname.toString())
  //               localStorage.setItem("projectIDSelected", project.projectid.toString())
  //               localStorage.removeItem("fromCommissioning")
  //               this.showPopupShop = false
  //               this.showFiltersModal = false
  //               this.popupNewEstimateQuick = false
  //               this.toggleWithShadingOptions()
  //               this.router.navigateByUrl(`/applications`)
  //             } else {

  //               this.searchProject.instance.reset()
  //               this.initForm()



  //               localStorage.setItem("ModuleFrom", "Estimate")
  //               let url = `/Estimates/editEstimate?numESTIMATEID=${estimateid}&strPROJECT_NAME=${project.projectname}&numProjectID=${project.projectid}`
  //               this.toast.success(this.translate.instant('msgEstCreSucc'));
  //               // this.router.navigateByUrl(url)
  //               this.popupNewEstimateQuick = false
  //               this.toggleWithShadingOptions()
  //               this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: estimateid, numProjectID: project.projectid, strPROJECT_NAME: project.projectname } });
  //             }
  //           }
  //         });
  //     }
  //   })
  // }


  showPopupPlane: boolean = false

  // Variables para el popup del plan
  currentBalance: number = 0
  estimateCost: number = 50.00
  remainingBalance: number = 0
  saveOrDuplicate: any = ""

  createEstimate() {
    let dataFinal = this.firstFormGroup.value

    if (dataFinal.projectid == null || dataFinal.projectid == undefined || dataFinal.projectid == 0 || dataFinal.projectid == "") {
      this.toast.warning("You must select a project")
      return
    }


    if (this.planid == "11") {

      this.showPopupPlane = true
      this.saveOrDuplicate = "Save"

    } else {
      let dataFinal = this.firstFormGroup.value
      const currentuserid = localStorage.getItem("customerid");
      let project = this.firstFormGroup.value;


      if (dataFinal.projectid == null || dataFinal.projectid == undefined || dataFinal.projectid == 0 || dataFinal.projectid == "") {
        this.toast.warning("You must select a project")
        return
      }

      this.estimateService.InsertEstimateWithTax(
        dataFinal.projectid,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        currentuserid,
        undefined,
        undefined,
      ).subscribe(result => {
        if (result[0]) {
          let estimateid = result[0].ID;
          this.estimateService
            .Insert_EstimateAreaCE(estimateid, 'Area 1', 0, 1, true)
            .subscribe((area) => {
              if (area[0]) {

                localStorage.setItem("ModuleFrom", "Estimate")

                localStorage.setItem("showModalInEdit", "Yes")
                
                this.showPopupPlane = false
              this.popupNewEstimateQuick = false
              this.withShadingOptionsVisible = false
              this.searchProject.instance.reset()
              this.searchProject.instance.repaint()
              this.searchProject.placeholder = "Search existing CUBE CRM projects, or click (+) to create a new one"
              
                this.toast.success(this.translate.instant('msgEstCreSucc'));
                this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: estimateid, numProjectID: project.projectid, strPROJECT_NAME: project.projectname } });
              }
            });
        }
      })

    }

  }


  SaveEstimatePay() {
    let dataFinal = this.firstFormGroup.value
    const currentuserid = localStorage.getItem("customerid");
    let project = this.firstFormGroup.value;


    if (dataFinal.projectid == null || dataFinal.projectid == undefined || dataFinal.projectid == 0 || dataFinal.projectid == "") {
      this.toast.warning("You must select a project")
      return
    }

    this.estimateService.InsertEstimateWithTax(
      dataFinal.projectid,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      currentuserid,
      undefined,
      undefined,
    ).subscribe(result => {
      if (result[0]) {
        let estimateid = result[0].ID;
        this.estimateService
          .Insert_EstimateAreaCE(estimateid, 'Area 1', 0, 1, true)
          .subscribe((area) => {
            if (area[0]) {


              localStorage.setItem("ModuleFrom", "Estimate")

              localStorage.setItem("showModalInEdit", "Yes")

              this.toast.success(this.translate.instant('msgEstCreSucc'));

              this.showPopupPlane = false
              this.popupNewEstimateQuick = false
              this.withShadingOptionsVisible = false

              this.MapInformationService.SaveInfoSites(
                {
                  "method": "AddClientCubeShopTransaction",
                  "clientid": localStorage.getItem("customerid"),
                  "amount": this.estimateCost * -1,
                  "details": "Estimate: " + project.projectname + ", Estimate ID: " + estimateid + ", Project ID: " + project.projectid
                }
              ).subscribe(respContract => {
                this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: estimateid, numProjectID: project.projectid, strPROJECT_NAME: project.projectname } });
              }, error => {
              })


            } else {
            }
          }, error => {
          });
      }
    })




  }


  createProject() {
    if (this.projectName != undefined) {
      let info =
      {
        "bidreqdate": "",
        "biddate": "",
        "projectid": 0,
        "projectnum": null,
        "name": this.projectName,
        "siteid": 0,
        "salescategoryid": 1,
        "bidstatus": 1,
        "closedate": "",
        "amount": 0,
        "profit": 0,
        "profitpercent": 0,
        "consultingid": 0,
        "salesemp": 0,
        "custreqpriceid": 0,
        "custawardprojectid": 0,
        "projectverticalid": 1,
        "awardedto": 0,
        "productspecified": 0,
        "partestimaterequestbyid": 0,
        "prevailingwagecode": 0,
        "notbidreason": 0,
        "salescomment": "",
        "salesnotes": "",
        "address": "",
        "addressline2": "",
        "city": "",
        "state": "",
        "country": "",
        "zip": "",
        "lat": 0,
        "lon": 0,
        "prevailingwage": 0,
        "method": "InsertUpdate_SalesProjectsCE"
      }

      this.MapInformationService.SaveInfoSites(info)
        .subscribe(resp => {

          console.log("resp", resp)
          console.log("info", info)
          console.log("this.projectName", this.projectName)


          this.firstFormGroup.get('projectid').setValue(resp[0].ReturnID);
          this.firstFormGroup.get('projectname').setValue(this.projectName);
          this.firstFormGroup.get('projectnameTemp').setValue(this.projectName);

          this.searchProject.placeholder = resp[0].ReturnID + " " + this.projectName

          this.toast.success("Project created successfully")
          this.projectName = ''
          this.popupCreateSalesProject = false
          this.popupCreateSalesProject2 = false

          this.initformAndSelect()
        })
    } else {
      this.toast.warning("You must write a name")
    }
  }



  @ViewChild('chatContainer', { static: true }) chatContainer!: ElementRef;
  @ViewChild('chatIframe', { static: true }) chatIframe!: ElementRef;
  @ViewChild('toggleButton', { static: true }) toggleButton!: ElementRef;
  showCbit: boolean = false

  isMinimized: boolean = false;

  toggleMinimizeChat(): void {
    this.isMinimized = !this.isMinimized;

    const icon = this.toggleButton.nativeElement.querySelector('i');
    if (this.isMinimized) {
      icon.classList.remove('fa-window-minimize');
      icon.classList.add('fa-window-maximize');
    } else {
      icon.classList.remove('fa-window-maximize');
      icon.classList.add('fa-window-minimize');
    }
  }

  closeChat(event: Event): void {
    this.chatContainer.nativeElement.style.display = 'none';
    event.stopPropagation();
  }

  goToCubeWork() {
    this.router.navigateByUrl('/clientDashboard');
  }

  goToClientDash() {
    this.router.navigateByUrl('/clientDashboard');
  }
  
  filterChats() {
    // this.unpinnedChats = this.unpinnedChats.filter(chat => chat.title.toLowerCase().includes(this.search.toLowerCase()));
  }

  navigateToMyAccount() {
    localStorage.setItem("showCreditsFirts", "Yes");
    this.router.navigate(['/my-account']);
    this.popupInsufficientCredits = false;
  }


}
